import settings from '../settings.js'

function initIdle(scope, rootScope, toastr, UserService) {
    scope.toastLoginTimeout = false;

    scope.$on('IdleWarn', IdleWarn);
    scope.$on('IdleTimeout', IdleTimeout);
    scope.$on('IdleEnd', IdleEnd);

    //Follows after the IdleStart event, but includes a countdown until the user is considered timed out
    //The countdown arg is the number of seconds remaining until then.
    //You can change the title or display a warning dialog from here.
    //You can let them resume their session by calling Idle.watch()
    function IdleWarn(e, countdown) {
        if (scope.toastLoginTimeout === false) {
            scope.$evalAsync(() => {
                scope.toastLoginTimeout = toastr.warning(
                    _locale('automatic logout in %s seconds', countdown).ucfirst(),
                    _locale('warning').ucfirst(),
                    {
                        extendedTimeOut: 0,
                        tapToDismiss: false,
                        timeOut: 0
                        //iconClass: 'toast-energized'
                    }
                );
            });
        }
        else {
            scope.$evalAsync(() => {
                scope.toastLoginTimeout.scope.message = _locale('automatic logout in %s seconds', countdown).ucfirst();
            });
        }
    }

    //The user has timed out (meaning idleDuration + timeout has passed without any activity)
    function IdleTimeout() {
        if (scope.eventListModal.isShown())
            scope.eventListModal.hide();

        if (rootScope.loginModal.isShown())
            rootScope.loginModal.hide();

        if (UserService.loginData.loginState === 2) { //Check just to be safe
            console.log("Idle doing logout");

            scope.logout().finally(() => {
                if (scope.toastLoginTimeout) {
                    scope.$evalAsync(() => {
                        toastr.clear();
                        scope.toastLoginTimeout = false;
                    });
                }
            });
        }
        else { //Idle triggered but already logged out?
            Idle.unwatch();
        }
    }

    //The user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
    function IdleEnd() {
        if (scope.toastLoginTimeout) {
            scope.$evalAsync(() => {
                toastr.clear();
                scope.toastLoginTimeout = false;
            });
        }
    }

}

export default initIdle